import { useEffect, useRef } from "react"

const IS_LOGGED_IN_MESSAGE_TYPE = "is-logged-in"

function isAllowedWebsiteOrigin(origin: string) {
  try {
    const { hostname } = new URL(origin)
    return (
      hostname === "clevergoose.tech" ||
      hostname === "www.clevergoose.tech" ||
      hostname === "localhost" ||
      hostname === "127.0.0.1"
    )
  } catch {
    return false
  }
}

export function IsLoggedInPage({
  isAuthenticated,
  isLoaded,
}: {
  isAuthenticated: boolean
  isLoaded: boolean
}) {
  const pendingOriginRef = useRef<string | null>(null)

  useEffect(() => {
    function reply(origin: string) {
      window.parent.postMessage(
        { type: IS_LOGGED_IN_MESSAGE_TYPE, loggedIn: isAuthenticated },
        origin,
      )
    }

    function onMessage(event: MessageEvent) {
      if (!isAllowedWebsiteOrigin(event.origin)) return
      if (event.data?.type !== IS_LOGGED_IN_MESSAGE_TYPE) return
      if (!isLoaded) {
        pendingOriginRef.current = event.origin
        return
      }
      reply(event.origin)
    }

    window.addEventListener("message", onMessage)

    if (isLoaded && pendingOriginRef.current) {
      reply(pendingOriginRef.current)
      pendingOriginRef.current = null
    }

    return () => window.removeEventListener("message", onMessage)
  }, [isAuthenticated, isLoaded])

  return null
}
